import Vue from 'vue'
import App from './App.vue'
import router from './router'
import BootstrapVue from 'bootstrap-vue'
import '@/assets/css/styles.scss'

Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.component('loading-screen', require('@/components/loader.vue').default);

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
